import {
  XAPI_EVENT_TYPES,
  XAPI_OBJECT_TYPES,
} from "@models/tracking/event-types";
import { ClickLinkEvent, xAPIEvent } from "@models/tracking/xapi-events";

export const SearchboxMethod = {
  KEY_PRESS: "key pressed",
  RESULT_SELECTED: "result selected",
};

export class ClickDocumentEvent extends ClickLinkEvent {
  constructor(document, { curriculumLevelId, curriculumLevelParentId } = {}) {
    const { id, name } = document;
    const objectId = `curriculum_resources_document_${id}`;

    const options = {
      curriculum_level_id: curriculumLevelId ?? null,
      curriculum_level_parent_id: curriculumLevelParentId ?? null,
    };

    super(objectId, name, options);
  }
}

export class FilterEvent extends xAPIEvent {
  constructor(name, value) {
    const objectId = `curriculum_resources_filter_${name}`;

    super(
      XAPI_EVENT_TYPES.FILTERED,
      {
        id: objectId,
        name,
        type: XAPI_OBJECT_TYPES.FILTER,
      },
      {
        filter_value: value,
      }
    );
  }
}

export class SearchEvent extends xAPIEvent {
  constructor(method, term, result) {
    const objectName = "search_bar";
    const objectId = `curriculum_resources_${objectName}`;

    super(
      XAPI_EVENT_TYPES.SEARCHED,
      {
        id: objectId,
        name: objectName,
        type: XAPI_OBJECT_TYPES.SEARCH_BAR,
      },
      {
        search_method: method,
        search_term: term,
        selected_result_text: result,
      }
    );
  }
}
